import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import ActCompletionWorkService from "../../services/ActCompletionWorkService";

let initialState = {
    actCompletionWorks: [],
    isLoading: false,
    hasMore: false,
    error: null,
}

export const getActCompletionWorks = createAsyncThunk(
    'getActCompletionWorks',
    async ({ page, limit, categoryId, teacherId }, {rejectWithValue}) => {
        try {
            const response = await ActCompletionWorkService.getACWs(page, limit, categoryId, teacherId);
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    },
);

const actCompletionWorkSlice = createSlice({
    name: 'actCompletionWorkSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getActCompletionWorks.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getActCompletionWorks.fulfilled, (state, action) => {
                state.isLoading = false;
                state.actCompletionWorks = action.payload.data;
                state.hasMore = action.payload.hasMore;
            })
            .addCase(getActCompletionWorks.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.actCompletionWorks = [];
                state.hasMore = false;
            })
    }
});

export const {} = actCompletionWorkSlice.actions;

export default actCompletionWorkSlice.reducer;
